"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSliderOptions = void 0;
var _constants = require("../constants");
const getSliderOptions = ({
  slider
}) => ({
  breakpoints: {
    ..._constants.SMALL_BREAKPOINT_SETTINGS,
    ..._constants.MEDIUM_BREAKPOINT_SETTINGS
  },
  slides: {
    perView: 'auto',
    spacing: _constants.SPACING
  },
  loop: false,
  ...slider
});
exports.getSliderOptions = getSliderOptions;
//# sourceMappingURL=getSliderOptions.js.map